var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionTransportBus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.586 2A3.414 3.414 0 0 1 20 5.414V18c0 .74-.403 1.384-1 1.73v.77a1.5 1.5 0 0 1-3 0V20H8v.5a1.5 1.5 0 0 1-3 0v-.77c-.597-.346-1-.99-1-1.73V5.414A3.414 3.414 0 0 1 7.414 2h9.172ZM7 16a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm10 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM6 8v6h12V8H6Zm3-4a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2H9Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionTransportBus);
export default __webpack_public_path__ + "static/media/ic_action_transport_bus.d1c4f3d68c6135738f3cc2fc0a304f8b.svg";
export { ForwardRef as ReactComponent };